import { render, staticRenderFns } from "./PanicAlert.vue?vue&type=template&id=632b04ec&scoped=true"
import script from "./PanicAlert.vue?vue&type=script&lang=js"
export * from "./PanicAlert.vue?vue&type=script&lang=js"
import style0 from "./PanicAlert.vue?vue&type=style&index=0&id=632b04ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../shieldgo-admin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632b04ec",
  null
  
)

export default component.exports